
export interface FilterData {
  markets: string[];
  regions: string[];
  brands: string[];
  channels: string[];
  tags: string[];
  date: {
    start: Date | null;
    end: Date | null;
  };
  dateOption?: string;
  role?: string;
  benchmarkId?: string;
}

export enum FilterViews {
  Filter = 'filter',
  Settings = 'settings',
  Audiences = 'audiences',
}

export enum CustomDateType {
  Start = 'start',
  End = 'end',
}

export interface FilterDataDTO {
  markets: number[];
  regions: number[];
  brands: number[];
  channels: number[];
  tags: number[];
  date: {
    start: string | null;
    end: string | null;
  };
  date_option?: string;
  role?: string;
}
